import React, { Fragment, useEffect, useState } from "react";
import useStyles from "./VendorPopUp.css";
import translation from "../../../i18n/i18.json";
import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useDispatch, useSelector } from "react-redux";
import AllActions from "../../../actions";
import { Company } from "../../../models/Company";
import { Po } from "../../../models/Po";
import { VendorUnBlockingService } from "../../../services/VendorUnBlockingService";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import { FormError } from "../../../models/FormValidation/FormError";
import {
  InforDisplyaDuration,
  ResponseObjectType,
  VendorForm1Modes,
  FieldsLengthConstants,
  Max_PermittedPayee_For_Vendor,
  VendorTypeData,
  VendorCategoryData,
  FileUploadTypes,
  SpendManagedByData,
  RequestTypes
} from "../../../constants/AppConstants";
import {
  AmendRequestData,
  BlockRequestData,
  ExtendRequestData,
  VendorRequestChangeData,
} from "../../../models/VendorRequestChange/VendorRequestChangeData";
// import { VendorExtendService } from "../../../services/VendorExtendService";
import { VendorAmendService } from "../../../services/VendorAmendService";
import { ReconAC } from "../../../models/ReconAC";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { PaymentMethod } from "../../../models/PaymentMethod";
import { HouseBank } from "../../../models/HouseBank";
import { CreditPeriodDays } from "../../../models/CreditPeriodDays";
import { SettlementCurrency } from "../../../models/SettlementCurrency";
import { TermsTrade } from "../../../models/TermsTrade";
import { VendorDetailPaymentMeta } from "../../../models/VendorDetail/VendorDetailPaymentMeta";
import { FormUtil } from "../../../utils/FormUtil";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import CancelIcon from "@material-ui/icons/Cancel";
import { SecondLevelCategory } from "../../../models/SecondLevelCategory";
import { VendorCreateState } from "../../../reducers/vendor/VendorCreateReducer";
import { RootState } from "../../../reducers";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import VendorSelectDialog from "./VendorSelectDialog";
import { SAPVendor } from "../../../models/SAPVendor";
import { Util } from "../../../utils/Util";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { VendorMasterData } from "../../../services/VendorMasterData";
import { Department } from "../../../models/Department";
import { User } from "../../../models/Master/User";
import { MasterDataService } from "../../../services/MasterDataService";
import { Country } from "../../../models/Country";
import { Common } from "../../../utils/Common";
import { RMCategory } from "../../../models/RMCategory";
import { ProcurementCategorySummary, ProcurementSubcategorySummary } from "../../../models/Master/ProcurementCategorySummary";
import { MasterMetaDataService } from "../../../services/MasterMetaDataService";
import { OnBoardingReason } from "../../../models/OnboardingReason";
import FileUpload from "../../FileUpload/FileUpload";
import { ApprovalPointUtil } from "../../../utils/ApprovalPointUtil";
import { Approver1n2Data } from "../../../models/Approval/Approver1n2Data";
import { InstructionKey } from "../../../models/InstructionKey";
import { PaymentPurpose } from "../../../models/PaymentPurpose";
import { MasterDataUtil } from "../../../utils/masterData/MasterDataUtil";
import ValidationErrors from "../../ErrorList/ValidationErrors";

interface RequestChangeDialogProps {
  open: boolean;
  handleClose: any;
  requestMode: VendorForm1Modes;
  title: string;
  onUpdateConfirm: any;
  vendorId: number;
  vendorNo: string;
  countryCode?: string;
  companyCodeList: Array<Company>;
  departmentList: Array<Department>;
  companyCode: string;
  poCodeList: Array<string>;
  vendorType?: string;
  countries: Array<Country>;
  getPreferedPaymentMethods: Function;
  rmCategoryList: RMCategory[];
  procurementSubCategorySummaryList: ProcurementSubcategorySummary[];
  procurementCategoryList: ProcurementCategorySummary[];
  onboardingReasonList: OnBoardingReason[];
  instructionKeyList: InstructionKey[];
  paymentpurposeList: PaymentPurpose[];
  secondLevelCategories: SecondLevelCategory[];
}

const icon = <CheckBoxOutlineBlankIcon />;
const checkedIcon = <CheckBoxIcon />;

export default function RequestChangeDialog(props: RequestChangeDialogProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    open,
    handleClose,
    requestMode,
    title,
    onUpdateConfirm,
    vendorId,
    vendorNo,
    countryCode,
    companyCodeList,
    departmentList,
    companyCode,
    poCodeList,
    vendorType,
    countries,
    getPreferedPaymentMethods,
    rmCategoryList,
    procurementSubCategorySummaryList,
    onboardingReasonList,
    instructionKeyList,
    paymentpurposeList,
    secondLevelCategories
  } = props;
  const [poList, setPoList] = useState(Array<Po>());
  const createVendor: VendorCreateState = useSelector<RootState, VendorCreateState>((state) => state.vendorCreateDetails);
  const vendorDetail: VendorDetailState = useSelector<RootState, VendorDetailState>((state) => state.vendorDetails);
  const [openPermittedPayeeDialog, setOpenPermittedPayeeDialog] = useState(false);
  const [approver1List, setApprover1List] = useState(Array<User>());
  const [approver2List, setApprover2List] = useState(Array<User>());
  const [approver1Lable, setApprover1Lable] = useState("");
  const [approver2Lable, setApprover2Lable] = useState("");
  const [spendManagedById, setSpendManagedById] = useState(Number);

  let initialState:
    | VendorRequestChangeData
    | ExtendRequestData
    | BlockRequestData
    | AmendRequestData = {
    departmentId: 0,
    vendorId: 0,
    vendorNo: "",
    coCode: "",
    poCode: [],
    comment: ""
  };
  switch (requestMode) {
    // case VendorForm1Modes.VendorInialUnBlock: {
    //   initialState = {
    //     departmentId: 0,
    //     vendorId: 0,
    //     vendorNo: "",
    //     coCode: "",
    //     poCode: [],
    //     comment:""
    //   };
    //   break;
    // }
    case VendorForm1Modes.VendorInialAmend: {
      initialState = {
        departmentId: 0,
        vendorId: 0,
        vendorNo: "",
        coCode: "",
        poCode: [],
        vendorName: "",
        reconAC: "",
        typeSubCategory: "",
        mobileNumber: "",
        email: "",
        isVendorFillForm2: false,
        isConfirmExistingData: false,
        firstApprovers: [],
        secondApprovers: [],
        comment: "",
        addressCoutry: "",
        paymentMethodCode: [],
        creditPeriodDays: "",
        orderCurrency: "",
        alternativeCurrency: [],
        termsOfTrade: "",
        isBulk: true,
        rmCategoryIds: [],
        onBoardReasonIds: [],
        onBoardReasonDescription: "",
        onboardReasonFile: { fileId: 0, fileName: "", filePath: "" },
        instructionKey: "",
        procurementCategoryIds: [],
        procurementSubcategoryIds: []
      };
      break;
    }
    case
      VendorForm1Modes.VendorInialBlock: {
        initialState = {
          departmentId: 0,
          vendorId: 0,
          vendorNo: "",
          coCode: "",
          poCode: [],
          vendorName: "",
          reconAC: "",
          typeSubCategory: "",
          mobileNumber: "",
          email: "",
          isVendorFillForm2: false,
          isConfirmExistingData: false,
          firstApprovers: [],
          secondApprovers: [],
          comment: "",
          addressCoutry: "",
          paymentMethodCode: [],
          creditPeriodDays: "",
          orderCurrency: "",
          alternativeCurrency: [],
          termsOfTrade: "",
          isBulk: true,
          rmCategoryIds: [],
          onBoardReasonIds: [],
          onBoardReasonDescription: "",
          onboardReasonFile: { fileId: 0, fileName: "", filePath: "" },
          instructionKey: "",
          procurementCategoryIds: [],
          procurementSubcategoryIds: []
        };
        break;
      }
    // case VendorForm1Modes.VendorInialExtend: {
    //   initialState = {
    //     departmentId: 0,
    //     sbuApprovers: [],
    //     GSSCCategoryLeadApprovers: [],
    //     vendorId: 0,
    //     vendorNo: props.vendorNo,
    //     sourceCoCode: props.companyCode,
    //     coCode: "",
    //     poCode: [],
    //     reconACCode: "",
    //     paymentMethodCode: [],
    //     houseBankCode: "",
    //     creditPeriodDays: "",
    //     accountingClarkEmail: "",
    //     accountingClark: "",
    //     orderCurrency: "",
    //     alternativeCurrency: [],
    //     termsOfTrade: "",
    //     permittedPayeeList: [],
    //     comment: ""
    //   };
    //   break;
    // }
    default:
      break;
  }

  const [vendorRequestChange, setVendorRequestChange] = useState<VendorRequestChangeData | ExtendRequestData | AmendRequestData>(initialState);
  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);
  const [isInitialVendorDetailData, setIsInitialVendorDetailData] = useState(false);

  const [reconAcList, setReconAcList] = useState(Array<ReconAC>());
  const [paymentmethod, setPaymentmethod] = useState(Array<PaymentMethod>());
  const [housebanks, setHousebanks] = useState(Array<HouseBank>());
  const [crediperioddays, setCrediperioddays] = useState(Array<CreditPeriodDays>());
  const [settlementcurrency, setSettlementcurrency] = useState(Array<SettlementCurrency>());
  const [termstrade, setTermstrade] = useState(Array<TermsTrade>());

  const [secondCategories, setSecondCategories] = useState(Array<SecondLevelCategory>());
  const [procurementSubCategories, setProcurementSubCategories] = useState(Array<ProcurementSubcategorySummary>());
  const [rmCategories, setRMCategories] = useState(Array<RMCategory>());
  const [procurementCategories, setProcurementCategories] = useState(Array<ProcurementCategorySummary>());
  const [procurementSubCategorySummaries, setProcurementSubCategorySummaries] = useState(Array<ProcurementSubcategorySummary>());
  const [vendorOnboardingReasons, setVendorOnboardingReasons] = useState(Array<OnBoardingReason>());
  const [openValidateErrDialog, setOpenValidateErrDialog] = useState(false);

  const prepareForLoading = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteLoading = (
    success: boolean,
    message?: string,
    duration?: number
  ) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      let messageduration = duration ? duration : InforDisplyaDuration.common;
      if (success) {
        dispatch(AllActions.infoActions.openInforSuccess(message, messageduration!));
      } else {
        dispatch(AllActions.infoActions.openInforError(message, messageduration!));
      }
    }
  };

  const clearApproverData = () => {
    setApprover1List([]);
    setApprover2List([]);
    setApprover1Lable("");
    setApprover2Lable("");
  }

  const getApproverData = (companyCode: string, vendorCategoryId: number, onBoardReasonIds: number[], isBulk: boolean, spendManagedById: number) => {
    return ApprovalPointUtil.getApproverData(companyCode, vendorCategoryId, onBoardReasonIds, isBulk
      , spendManagedById, RequestTypes.VendorAmend
      , (approver1n2Data: Approver1n2Data) => {
        setApprover1List(approver1n2Data.approver1List);
        setApprover2List(approver1n2Data.approver2List);
        setApprover1Lable(approver1n2Data.approver1Lable);
        setApprover2Lable(approver1n2Data.approver2Lable);
      });
  }

  const isOnboardingReasonActive = (reasonId: number) => {
    return (!vendorRequestChange.onBoardReasonIds || vendorRequestChange.onBoardReasonIds.length == 0
      || ApprovalPointUtil.isOnboardingReasonAllowed(vendorRequestChange.onBoardReasonIds, reasonId))
      ? true : false;
  }

  //used only for amend
  const addMissingReconAc = (reconACData: Array<ReconAC>, reconAc: string) => {
    let matchingRecon = reconACData.find((recon) => {
      return recon.code === reconAc;
    });
    if (!matchingRecon) {
      reconACData.push({ code: reconAc, name: reconAc });
    }
  }

  const getCoDataforAmend = (coCode: string) => {
    return Promise.allSettled([
      VendorDetailService.getPO(
        coCode,
        function (poData: Array<Po>) {
          //get only vendor related POs
          if (poCodeList && poCodeList.length > 0) {
            poData = poData.filter((po) => {
              return poCodeList.indexOf(po.code) >= 0;
            });
          } else {
            poData = [];
          }
          setPoList(poData);
          if (poData && poData.length === 1) {
            // setTimeout( () => {
            //   setVendorRequestChange({...vendorRequestChange!,"poCode": [poData[0].code]});
            // },0);
            vendorRequestChange.poCode = [poData[0].code];
          }
        },
        function () {
          setPoList([]);
        }
      ),
      // getApproverData(vendorRequestChange.coCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
      //   , createVendor.IsBulk, spendManagedById),
      VendorDetailService.getReconAC(
        coCode,
        vendorType!,
        function (reconACData: Array<ReconAC>) {
          addMissingReconAc(reconACData, vendorRequestChange.reconAC);
          setReconAcList(reconACData);
        },
        function (error: Error) {
          console.log(error);
          setReconAcList([]);
        }
      )
      // VendorDetailService.getSecondLevelCategory(
      //   vendorType!,
      //   function (secondCategoryData: Array<SecondLevelCategory>) {
      //     console.log(secondCategoryData);
      //     setSecondCategories(secondCategoryData);
      //   },
      //   function (error: Error) {
      //     console.log(error);
      //     setSecondCategories([]);
      //   }
      // )
      //getPromiseContactDetailMetaData()
    ]).then(() => {
      compeleteLoading(true);
    });
  };

  const getSecondLevelCategory = (vendorType: string) => {
    if (secondLevelCategories && secondLevelCategories.length > 0) {
      setSecondCategories(secondLevelCategories);
      return Promise.resolve(secondLevelCategories);
    } else {
      return VendorDetailService.getSecondLevelCategory(
        vendorType,
        function (secondCategoryData: Array<SecondLevelCategory>) {
          setSecondCategories(secondCategoryData);
        },
        function () {
          setSecondCategories([]);
        }
      );
    }
  };

  // const getDataforExtend = () => {
  //   //dropdownDataRequestsCounter = 0;
  //   prepareForLoading();
  //   Promise.allSettled([
  //     VendorExtendService.getPO(
  //       vendorId,
  //       vendorRequestChange.coCode,
  //       function (poData: Array<Po>) {
  //         setPoList(poData);
  //       },
  //       function (error: Error) {
  //         console.log(error);
  //         setPoList([]);
  //       }
  //     ),
  //     getApproverData(vendorRequestChange.coCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
  //       , createVendor.IsBulk, spendManagedById),
  //     VendorDetailService.getReconAC(
  //       vendorRequestChange.coCode,
  //       vendorType!,
  //       function (reconACData: Array<ReconAC>) {
  //         setReconAcList(reconACData);
  //       },
  //       function (error: Error) {
  //         console.log(error);
  //         setReconAcList([]);
  //       }
  //     ),
  //     countryCode
  //       ? VendorMasterData.getPreferedPaymentMethods(
  //           vendorRequestChange.coCode,
  //           countryCode,
  //           function (paymethodsList: Array<PaymentMethod>) {
  //             const i = paymethodsList.map(i => i.code).indexOf('H')
  //             if (i > 0) {
  //                 const filtered = paymethodsList
  //                 filtered.splice(i, 1)
  //                 setPaymentmethod(filtered)
  //             } else {
  //               setPaymentmethod(paymethodsList);
  //             }

  //           },
  //           function (error: Error) {
  //             console.log(error);
  //             setPaymentmethod([]);
  //           }
  //         )
  //       : undefined,
  //     VendorMasterData.getHouseBank(
  //       vendorRequestChange.coCode,
  //       function (houseBankList: Array<HouseBank>) {
  //         setHousebanks(houseBankList);
  //       },
  //       function (error: Error) {
  //         console.log(error);
  //         setHousebanks([]);
  //       }
  //     ),
  //   ]).then(() => {
  //     compeleteLoading(true);
  //   });
  // };

  // useEffect(() => {
  //   if (vendorRequestChange.coCode) {
  //     switch (requestMode) {
  //       // case VendorForm1Modes.VendorInialAmend: {
  //       //   getCoDataforAmend();
  //       //   break;
  //       // }
  //       case VendorForm1Modes.VendorInialExtend: {
  //         getDataforExtend();
  //         break;
  //       }
  //       default:
  //         break;
  //     }
  //   } else {
  //     setPoList([]);
  //   }
  // }, [vendorRequestChange.coCode]);

  useEffect(() => {
    if (vendorRequestChange.procurementCategoryIds && vendorRequestChange.procurementCategoryIds.length > 0) {
      let procurementSubcats: ProcurementSubcategorySummary[] = [];
      procurementSubCategorySummaries.forEach(p => {
        if (vendorRequestChange.procurementCategoryIds.find((e: number) => e == p.procurmentCategoryId)) {
          procurementSubcats.push(p);
        }
      });
      setProcurementSubCategories(procurementSubcats);
      if (vendorRequestChange.procurementSubcategoryIds
        && !procurementSubcats.find(v => v.procurmentSubcategoryId === vendorRequestChange.procurementSubcategoryIds[0])) {
        //if not matching remove
        vendorRequestChange.procurementSubcategoryIds = [];
      }
    } else {
      vendorRequestChange.procurementSubcategoryIds = [];
      setProcurementSubCategories([]);
    }
  }, [vendorRequestChange.procurementCategoryIds]);

  useEffect(() => {
    if (vendorRequestChange.procurementSubcategoryIds && vendorRequestChange.procurementSubcategoryIds.length > 0) {
      //if (!isInitialVendorDetailData) {
      let procSubCat = procurementSubCategorySummaries.find(v => v.procurmentSubcategoryId == vendorRequestChange.procurementSubcategoryIds[0]);
      setVendorRequestChange({ ...vendorRequestChange!, "spendManagedById": (procSubCat ? procSubCat.spendManagedById : null) });
      //}
    } else {
      setVendorRequestChange({ ...vendorRequestChange!, "spendManagedById": null });
    }
  }, [vendorRequestChange.procurementSubcategoryIds]);

  useEffect(() => {
    if (vendorRequestChange.coCode && vendorRequestChange.coCode.length > 0
      && createVendor.VendorCategoryId > 0) {
      if (!isInitialVendorDetailData) {
        //showLoadingMask();
        getApproverData(createVendor.CompanyCode, createVendor.VendorCategoryId, vendorRequestChange.onBoardReasonIds
          , vendorRequestChange.isBulk, vendorRequestChange.spendManagedById);
      }
    } else {
      clearApproverData();
    }
  }, [vendorRequestChange.isBulk, vendorRequestChange.onBoardReasonIds, vendorRequestChange.spendManagedById]);


  // const getOkButtonText = () => {
  //   switch (requestMode) {
  //     // case VendorForm1Modes.VendorInialUnBlock:
  //     //   return translation.vendorchangepopup_unblock_btn;
  //     case VendorForm1Modes.VendorInialExtend:
  //       return translation.vendorchangepopup_extend_btn;
  //     case VendorForm1Modes.VendorInialAmend:
  //       return translation.vendorchangepopup_amend_btn;
  //     default:
  //       return "";
  //   }
  // };

  //Only for extend
  // const updateWithExistingVendorData = () => {
  //   //check vendor company is included in extend co list - if all extended, co will not appear in the list
  //   let vendorCompany = companyCodeList.find(
  //     (company: Company) => {
  //       return company.code === companyCode;
  //     }
  //   );
  //   if (vendorCompany) {
  //     setVendorRequestChange({
  //       ...vendorRequestChange!,
  //       "vendorId": vendorId,
  //       "vendorNo": vendorNo,
  //       "poCode": [],
  //       "coCode": companyCode,
  //       "reconACCode": vendorDetail.ReconAC,
  //       "paymentMethodCode": vendorDetail.PrefPayMethod,
  //       "houseBankCode": vendorDetail.HouseBank,
  //       "creditPeriodDays": vendorDetail.CreditPeriodDays,
  //       "accountingClarkEmail": vendorDetail.AccoutingEmail,
  //       "accountingClark": vendorDetail.AccoutingClark,
  //       "orderCurrency": vendorDetail.orderCurrency,
  //       "alternativeCurrency": vendorDetail.alternativeCurrency,
  //       "termsOfTrade": vendorDetail.TermsOfTrade,
  //       "permittedPayeeList": vendorDetail.permittedPayeeList,
  //       "addressCoutry": vendorDetail.AddressCoutry,
  //       "isBulk": createVendor.IsBulk,
  //       "rmCategoryIds": createVendor.RMCategoryIds,
  //       "procurementCategoryIds": createVendor.ProcurementCategoryIds,
  //       "procurementSubcategoryIds": createVendor.ProcurementSubcategoryIds,
  //       "onBoardReasonIds": createVendor.OnBoardReasonIds,
  //       "onBoardReasonDescription": createVendor.OnBoardReasonDescription,
  //       "purposeCode": createVendor.purposeCode,
  //       "instructionKey": createVendor.InstructionKey,
  //       "onboardReasonFile": createVendor.OnboardReasonFile
  //     });
  //   }
  // };

  const loadPaymentMetaData = (coCountryCode: string) => {
    return VendorMasterData.getPaymentDetailMetaData(
      coCountryCode,
      function (paymentData: VendorDetailPaymentMeta) {
        setTermstrade(paymentData.termsOfTrades);
        setCrediperioddays(paymentData.creditPeriodDays);
        setSettlementcurrency(paymentData.settlementCurencies);
        compeleteLoading(true);
      },
      function (error: Error) {
        console.log(error);
        setTermstrade([]);
        setCrediperioddays([]);
        setSettlementcurrency([]);
        compeleteLoading(false);
      }
    );
  };

  const resetVendorDataForNoChange = () => {
    setVendorRequestChange({
      ...vendorRequestChange!,
      "vendorId": vendorId,
      "vendorNo": vendorNo,
      "coCode": companyCode,
      "vendorName": createVendor.VendorName,
      "reconAC": createVendor.ReconAC,
      "typeSubCategory": createVendor.TypeSubCategory,
      "mobileNumber": createVendor.MobileNumber,
      "email": createVendor.Email,
      "isVendorFillForm2": false,//
      "isConfirmExistingData": true,//
      "paymentMethodCode": createVendor.PrefPayMethod,
      "creditPeriodDays": createVendor.CreditPeriodDays,
      "orderCurrency": createVendor.orderCurrency,
      "alternativeCurrency": createVendor.alternativeCurrency,
      "termsOfTrade": createVendor.TermsOfTrade,
      "addressCoutry": createVendor.AddressCoutry,
      "isBulk": createVendor.IsBulk,
      "rmCategoryIds": createVendor.RMCategoryIds,
      "procurementCategoryIds": createVendor.ProcurementCategoryIds,
      "procurementSubcategoryIds": createVendor.ProcurementSubcategoryIds,
      "onBoardReasonIds": createVendor.OnBoardReasonIds,
      "onBoardReasonDescription": createVendor.OnBoardReasonDescription,
      "purposeCode": createVendor.purposeCode,
      "instructionKey": createVendor.InstructionKey,
      "onboardReasonFile": createVendor.OnboardReasonFile
    });
  }

  const loadAmendInitialData = () => {
    prepareForLoading();//mask
    setIsInitialVendorDetailData(true);
    setVendorRequestChange({
      ...vendorRequestChange!,
      "vendorId": vendorId,
      "vendorNo": vendorNo,
      "coCode": companyCode,
      "vendorName": createVendor.VendorName,
      "reconAC": createVendor.ReconAC,
      "typeSubCategory": createVendor.TypeSubCategory,
      "mobileNumber": createVendor.MobileNumber,
      "email": createVendor.Email,
      "isVendorFillForm2": createVendor.IsVendorFillForm2,
      "isConfirmExistingData": false,
      "paymentMethodCode": createVendor.PrefPayMethod,
      "creditPeriodDays": createVendor.CreditPeriodDays,
      "orderCurrency": createVendor.orderCurrency,
      "alternativeCurrency": createVendor.alternativeCurrency,
      "termsOfTrade": createVendor.TermsOfTrade,
      "addressCoutry": createVendor.AddressCoutry,
      "isBulk": createVendor.IsBulk,
      "rmCategoryIds": createVendor.RMCategoryIds,
      "procurementCategoryIds": createVendor.ProcurementCategoryIds,
      "procurementSubcategoryIds": createVendor.ProcurementSubcategoryIds,
      "onBoardReasonIds": createVendor.OnBoardReasonIds,
      "onBoardReasonDescription": createVendor.OnBoardReasonDescription,
      "purposeCode": createVendor.purposeCode,
      "instructionKey": createVendor.InstructionKey,
      "onboardReasonFile": createVendor.OnboardReasonFile
    });
    let promiseList = [
      loadPaymentMetaData(createVendor.CompanyCodeCountry),
      getPreferedPaymentMethods(companyCode
        , createVendor.AddressCoutry
        , (paymethodsList: Array<PaymentMethod>) => { setPaymentmethod(paymethodsList); }
        , () => { setPaymentmethod([]); }),
      //load co master data
      getCoDataforAmend(companyCode),
      //approvers
      getApproverData(companyCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
        , createVendor.IsBulk, spendManagedById),
      //second level category
      getSecondLevelCategory(vendorType!)];
    //Load RM, NonRm, Service data
    if (isRmOrNonRmOrServices()) {
      if (createVendor.VendorCategoryId == VendorCategoryData.RM) {
        if (rmCategoryList && rmCategoryList.length > 0) {
          setRMCategories(rmCategoryList);
        } else {
          promiseList.push(getPromiseRMCategoryData(createVendor.VendorCategoryId));
        }
      } else {
        if (procurementSubCategorySummaryList && procurementSubCategorySummaryList.length > 0) {
          setProcurementSubCategorySummaries(Util.sortObjByString(procurementSubCategorySummaryList, "procurmentCategoryName") as ProcurementSubcategorySummary[]);
          setProcurementCategories(MasterDataUtil.getProcurementCategories(procurementSubCategorySummaryList));
          //loadProcurementCatList(procurementSubCategorySummaryList);
        } else {
          promiseList.push(getPromiseProcurmentSubcategoryData(createVendor.VendorCategoryId));
        }
      }
      if (onboardingReasonList && onboardingReasonList.length > 0) {
        setVendorOnboardingReasons(onboardingReasonList);
      } else {
        promiseList.push(getPromiseOnboardingReasons(createVendor.VendorCategoryId));
      }
    }
    Promise.allSettled(promiseList)
      .then(() => {
        compeleteLoading(true);
      });
  };

  const isRmOrNonRmOrServices = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.NonRM
      || createVendor.VendorCategoryId == VendorCategoryData.Services
      || createVendor.VendorCategoryId == VendorCategoryData.RM;
  };

  const isNonRmOrServices = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.NonRM
      || createVendor.VendorCategoryId == VendorCategoryData.Services;
  };

  const isProcurementSubCatComplete = () => {
    return procurementSubCategorySummaries.filter(v => vendorRequestChange.procurementSubcategoryIds.indexOf(v.procurmentSubcategoryId) > -1)
      .map(v => v.procurmentCategoryId).filter((value, index, array) => array.indexOf(value) === index).length < vendorRequestChange.procurementCategoryIds.length
      ? false : true;
  };

  const isServicesBySbu = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.Services
      && (vendorRequestChange.spendManagedById == SpendManagedByData.SBU
        || vendorRequestChange.spendManagedById == SpendManagedByData.GroupProcurementAndSBU);
  };

  const handleEnter = () => {
    prepareForLoading();
    setSpendManagedById(createVendor.SpendManagedById || 0);
    loadAmendInitialData();

    // if (requestMode === VendorForm1Modes.VendorInialExtend) {
    //   loadPaymentMetaData("");
    // }
    // if (requestMode === VendorForm1Modes.VendorInialAmend) {
    //   loadAmendInitialData();
    // }

    // if (requestMode === VendorForm1Modes.VendorInialExtend) {
    //   updateWithExistingVendorData();
    // }
  };

  const handleExit = () => {
    setVendorRequestChange(initialState);
    setFormErrors([]);
    setFistSubmitDone(false);
  };

  // const submitUnblockRequest = () => {
  //   prepareForLoading();
  //   VendorUnBlockingService.submitVendorUnBlockRequest(
  //     vendorRequestChange,
  //     function (vendorUnBlockData: any) {
  //       if (
  //         vendorUnBlockData &&
  //         vendorUnBlockData.resposeObjectType === ResponseObjectType.Error
  //       ) {
  //         compeleteLoading(false, vendorUnBlockData.message);
  //       } else {
  //         compeleteLoading(
  //           true,
  //           `${vendorUnBlockData.result} ${translation.vendorchangepopup_unblock_sucess}`,
  //           InforDisplyaDuration.approvalStatus
  //         );
  //         onUpdateConfirm();
  //       }
  //     },
  //     function (error: Error) {
  //       console.log(error);
  //       compeleteLoading(
  //         false,
  //         translation.vendorchangepopup_unblock_error_err
  //       );
  //     }
  //   );
  // };

  const submitAmendRequest = () => {
    prepareForLoading();
    VendorAmendService.submitVendorAmendRequest(
      vendorRequestChange,
      function (vendoramendData: any) {
        if (
          vendoramendData &&
          vendoramendData.resposeObjectType === ResponseObjectType.Error
        ) {
          compeleteLoading(false, vendoramendData.message);
        } else {
          compeleteLoading(
            true,
            `${vendoramendData.result.requestNo} ${translation.vendorchangepopup_amend_sucess}`
          );
          onUpdateConfirm(vendoramendData.result);
        }
      },
      function (error: Error) {
        console.log(error);
        compeleteLoading(false, translation.vendorchangepopup_amend_error_err);
      }
    );
  };

  // const submitExtendRequest = () => {
  //   prepareForLoading();
  //   VendorExtendService.submitVendorExtendRequest(
  //     vendorRequestChange,
  //     function (vendorExtendData: any) {
  //       if (
  //         vendorExtendData &&
  //         vendorExtendData.resposeObjectType === ResponseObjectType.Error
  //       ) {
  //         compeleteLoading(false, vendorExtendData.message);
  //       } else {
  //         compeleteLoading(
  //           true,
  //           `${vendorExtendData.result} ${translation.vendorchangepopup_extend_sucess}`,
  //           InforDisplyaDuration.approvalStatus
  //         );
  //         onUpdateConfirm();
  //       }
  //     },
  //     function (error: Error) {
  //       console.log(error);
  //       compeleteLoading(false, translation.vendorchangepopup_extend_error_err);
  //     }
  //   );
  // };

  const handleConfirm = () => {
    setOpenValidateErrDialog(false);
    setFistSubmitDone(true);
    if (validateData(true)) {
      submitAmendRequest();
      // switch (requestMode) {
      //   // case VendorForm1Modes.VendorInialUnBlock: {
      //   //   submitUnblockRequest();
      //   //   break;
      //   // }
      //   case VendorForm1Modes.VendorInialAmend: {
      //     submitAmendRequest();
      //     break;
      //   }
      //   case VendorForm1Modes.VendorInialExtend: {
      //     submitExtendRequest();
      //     break;
      //   }
      //   default:
      //     break;
      // }
    } else {
      setOpenValidateErrDialog(true);
    }
  };

  const getPromiseRMCategoryData = (vendorCategoryId: number) => {
    return vendorCategoryId == VendorCategoryData.RM
      ? MasterMetaDataService.getRMCategories(
        function (userRmCategoryList: Array<RMCategory>) {
          setRMCategories(userRmCategoryList);
        },
        function () {
          setRMCategories([]);
        }
      )
      : Promise.resolve([]);
  };
  const getPromiseOnboardingReasons = (vendorCategoryId: number) => {
    return MasterMetaDataService.getOnBoardingReasons(
      vendorCategoryId,
      function (onboardingReasonList: Array<OnBoardingReason>) {
        setVendorOnboardingReasons(onboardingReasonList);
      },
      function () {
        setVendorOnboardingReasons([]);
      }
    );
  };

  // const loadProcurementCatList = (procurementCatList: ProcurementSubcategorySummary[]) => {
  //   let procurementCats: ProcurementCategorySummary[] = [];
  //   procurementCatList.forEach(p => {
  //     if(!procurementCats.find(e => e.procurmentCategoryId == p.procurmentCategoryId)){
  //       procurementCats.push({ 
  //         vendorCategoryId : p.vendorCategoryId, 
  //         procurmentCategoryId: p.procurmentCategoryId, 
  //         procurmentCategoryName : p.procurmentCategoryName 
  //       });
  //     }
  //   });
  //   setProcurementCategories(Util.sortObjByString(procurementCats, "procurmentCategoryName") as ProcurementCategorySummary[]); 
  // };

  const getPromiseProcurmentSubcategoryData = (vendorCategoryId: number) => {
    return (vendorCategoryId == VendorCategoryData.NonRM
      || vendorCategoryId == VendorCategoryData.Services)
      ? MasterDataService.getProcurementSubcategorySummaries(
        RequestTypes.VendorAmend,
        vendorCategoryId,
        function (procurementCatList: Array<ProcurementSubcategorySummary>) {
          setProcurementSubCategorySummaries(Util.sortObjByString(procurementCatList, "procurmentCategoryName") as ProcurementSubcategorySummary[]);
          setProcurementCategories(MasterDataUtil.getProcurementCategories(procurementCatList));
          //loadProcurementCatList(procurementCatList);      
        },
        function () {
          setProcurementSubCategorySummaries([]);
        }
      )
      : Promise.resolve([]);
  };

  const handleChange = (input: string) => (e: any) => {
    if (input === "poCode") {
      if (e.target.value == "") {
        setVendorRequestChange({ ...vendorRequestChange!, [input]: [], });
      } else {
        setVendorRequestChange({ ...vendorRequestChange!, [input]: [e.target.value], });
      }
    } else if (input === "isVendorFillForm2") {
      setVendorRequestChange({ ...vendorRequestChange!, [input]: e.target.checked, });
      createVendor.IsVendorFillForm2 = e.target.checked;
    } else if (input === "isConfirmExistingData") {
      setVendorRequestChange({ ...vendorRequestChange!
        , [input]: e.target.checked
        , isVendorFillForm2:false });
      // createVendor.IsConfirmExistingData = e.target.checked;
      if(e.target.checked){ 
        resetVendorDataForNoChange();
      }
    } else if (input === "isBulk") {
      setVendorRequestChange({ ...vendorRequestChange!, [input]: e.target.value == "true" ? true : false });
    }
    // else if (input === "rmCategoryIds") {
    //       setVendorRequestChange({...vendorRequestChange!,[input]: e.target.value ? [e.target.value] : []});
    // }
    else if (input === "onBoardReasonIds") {
      let newValue = e.target.value
        ? e.target.value.find((v: number) => !vendorRequestChange.onBoardReasonIds.includes(v))
        : null;
      if (!(newValue && vendorRequestChange.onBoardReasonIds.length > 0) //delete or first value
        || ApprovalPointUtil.isOnboardingReasonAllowed(vendorRequestChange.onBoardReasonIds, newValue)) {
        setVendorRequestChange({ ...vendorRequestChange!, [input]: e.target.value, });
      }
      else {
        //not allowed
        dispatch(AllActions.infoActions.openInforError(translation.vendor_crete_form1_onboarding_reason_not_allowed_msg, InforDisplyaDuration.common));
      }
    }
    else if (input === "rmCategoryIds" || input === "procurementCategoryIds" || input === "procurementSubcategoryIds") {
      setVendorRequestChange({ ...vendorRequestChange!, [input]: e.target.value ? [e.target.value] : [] });
    }
    else if (input === "mobileNumber") {
      var re = /^[1-9][0-9]*$/im;
      if (e.target.value === '' 
        || e.nativeEvent.inputType == 'deleteContentBackward' || e.nativeEvent.inputType == 'deleteContentForward'
        || re.test(e.target.value)) {
        setVendorRequestChange({ ...vendorRequestChange!, [input]: e.target.value, });
      }
    }
    else {
      setVendorRequestChange({ ...vendorRequestChange!, [input]: e.target.value, });
    }
  };

  const handleDelete = (e: React.MouseEvent, value: any, input: string) => {
    e.preventDefault();
    if (input === "poCode") {
      setVendorRequestChange({
        ...vendorRequestChange!
        , "poCode": vendorRequestChange.poCode.filter((code) => { return code !== value; })
      });
    }
    else if (input === "firstApprovers") {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "firstApprovers": vendorRequestChange.firstApprovers.filter((email: string) => { return email !== value; })
      });
    }
    else if (input === "secondApprovers") {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "secondApprovers": vendorRequestChange.secondApprovers.filter((email: string) => { return email !== value; })
      });
    }
    else if (input === "paymentMethodCode") {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "paymentMethodCode": vendorRequestChange.paymentMethodCode.filter((code: string) => { return code !== value; })
      });
    } else if (input === "onBoardReasonIds") {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "onBoardReasonIds": vendorRequestChange.onBoardReasonIds.filter((id: number) => { return id !== value; })
      });
    } else if (input === "rmCategoryIds") {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "rmCategoryIds": vendorRequestChange.rmCategoryIds.filter((id: number) => { return id !== value; })
      });
    } else if (input === "procurementCategoryIds") {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "procurementCategoryIds": vendorRequestChange.procurementCategoryIds.filter((id: number) => { return id !== value; })
      });
    } else if (input === "procurementSubcategoryIds") {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "procurementSubcategoryIds": vendorRequestChange.procurementSubcategoryIds.filter((id: number) => { return id !== value; })
      });
    }
  };

  const getErrorState = (input: string) => {
    var errIndex = formErrors.findIndex(function (row) {
      return row.fieldName === input && row.errorMsg;
    });
    return errIndex !== -1 ? true : false;
  };

  useEffect(() => {
    if (isInitialVendorDetailData) {
      setIsInitialVendorDetailData(false);
    }
    if (fistSubmitDone) {
      validateData(false);
    }
  }, [vendorRequestChange]);

  const isPoRequired = () => {
    return (vendorType !== VendorTypeData.Employee
      && (!isNewCopany() || vendorType === VendorTypeData.RMProductionRelated || vendorType === VendorTypeData.FixedAssetsConsumables))
      ? true : false;
  };

  const validateData = (isSubmit: boolean) => {
    setFormErrors([]);
    //recone/subCat set blank if not matching with defined list
    let existRecon = reconAcList.find((r) => {
      return r.code === vendorRequestChange.reconAC;
    });
    if (!existRecon) {
      vendorRequestChange.reconAC = "";
    }
    let existSubCat = secondCategories.find((r) => {
      return r.code === vendorRequestChange.typeSubCategory;
    });
    if (!existSubCat) {
      vendorRequestChange.typeSubCategory = "";
    }
    //let valid = true;
    let validateFieldsData: Array<FormFieldMeta> = [
      {
        fieldName: "coCode",
        isRequired: true,
        reuiredMsg: "Company code is required",
      },
      {
        fieldName: "poCode",
        isRequired: false,
        reuiredMsg: "Purcg Org is required",
        isList: true,
      },
    ];

    if (requestMode == VendorForm1Modes.VendorInialAmend) {
      validateFieldsData = [
        {
          fieldName: "departmentId",
          isRequired: true,
          reuiredMsg: "Department is required",
        },
        {
          fieldName: "coCode",
          isRequired: true,
          reuiredMsg: "Company code is required",
        },
        {
          fieldName: "poCode",
          isRequired: false,
          reuiredMsg: "Purcg Org is required",
          isList: true,
        },
        {
          fieldName: "firstApprovers",
          isRequired: !isRmOrNonRmOrServices() || isServicesBySbu(),
          reuiredMsg: approver1Lable + " required",
          isList: true,
        },
        {
          fieldName: "secondApprovers",
          isRequired: !isRmOrNonRmOrServices(),
          reuiredMsg: approver2Lable + " required",
          isList: true,
        },
        {
          fieldName: "vendorName",
          isRequired: true,
          reuiredMsg: "VendorName is required",
        },
        {
          fieldName: "rmCategoryIds",
          isRequired: createVendor.VendorCategoryId == VendorCategoryData.RM ? true : false,
          reuiredMsg: "RM Category is required",
          isList: true
        },
        {
          fieldName: "onBoardReasonIds",
          isRequired: isRmOrNonRmOrServices() && !vendorRequestChange.isConfirmExistingData,
          reuiredMsg: "Onboarding Reason is required",
          isList: true
        },
        {
          fieldName: "onBoardReasonDescription",
          isRequired: (createVendor.VendorCategoryId == VendorCategoryData.RM ? true : false) && !vendorRequestChange.isConfirmExistingData,
          reuiredMsg: "Onboarding Description is required",
        },
        {
          fieldName: "procurementCategoryIds",
          isRequired: isNonRmOrServices(),
          reuiredMsg: "Procurement Category is required",
          isList: true
        },
        {
          fieldName: "procurementSubcategoryIds",
          isRequired: isNonRmOrServices(),
          reuiredMsg: "Procurement Subcategory is required",
          isList: true
        },
        {
          fieldName: "typeSubCategory",
          isRequired: true,
          reuiredMsg: "Type SubCategory is required",
        },
        {
          fieldName: "reconAC",
          isRequired: !vendorRequestChange.isConfirmExistingData,
          reuiredMsg: "Recon/AC is required",
        },
        {
          fieldName: "addressCoutry",
          isRequired: true,
          reuiredMsg: "Country is required",
        },
        {
          fieldName: "paymentMethodCode",
          isRequired: true,
          reuiredMsg: "Preferred Payment Method is required",
          isList: true,
        },
        {
          fieldName: "creditPeriodDays",
          isRequired: true,
          reuiredMsg: "Credit Period is required",
        },
        {
          fieldName: "orderCurrency",
          isRequired: isPoAvailable(),
          reuiredMsg: "Order Currency is required",
        },
        {
          fieldName: "alternativeCurrency",
          isRequired: false,
          reuiredMsg: "Alternative Currency is required",
          isList: true,
        },
        {
          fieldName: "termsOfTrade",
          isRequired: isPoAvailable(),
          reuiredMsg: "TermsOfTrade is required",
        },
        {
          fieldName: "mobileNumber",
          isRequired: true,
          reuiredMsg: "MobileNumber is required",
          formatFunc: vendorRequestChange.mobileNumber
            ? FormUtil.isValidVendorPhoneNumber.bind(
              vendorRequestChange.mobileNumber
            )
            : undefined,
          formatMsg: translation.vendor_crete_form1_mobilenformt_error,
        },
        {
          fieldName: "email",
          isRequired: vendorRequestChange.isVendorFillForm2,
          reuiredMsg: "Email is required",
          formatFunc: vendorRequestChange.email
            ? FormUtil.isValidEmail.bind(vendorRequestChange.email)
            : undefined,
          formatMsg: translation.vendor_crete_form1_emailfomat_error,
        },
      ];
    }

    let formValidateData: FormValidateData = FormUtil.validateFields(
      validateFieldsData,
      vendorRequestChange
    );
    //Onboarding reason doc
    if (createVendor.VendorCategoryId == VendorCategoryData.RM
      && !vendorRequestChange.isConfirmExistingData
      && !(vendorRequestChange.onboardReasonFile.fileId > 0)) {
      formValidateData.errorsList.push({ fieldName: "onboardReasonFile", errorMsg: "Onboarding Reason Document is required" });
      formValidateData.isValid = false;
    }
    //Proc sub cat list
    if (isNonRmOrServices()) {
      if (isSubmit && !isProcurementSubCatComplete()) {
        if (formValidateData.isValid) {
          dispatch(AllActions.infoActions.openInforError("Procurement Subcategories are incomplete.", InforDisplyaDuration.common));
        }
        formValidateData.errorsList.push({ fieldName: "ProcurementSubcategoryIds", errorMsg: "Procurement Subcategories are incomplete." });
        formValidateData.isValid = false;
      }
    }

    setFormErrors(formValidateData.errorsList);
    return formValidateData.isValid;
  };

  const isPoAvailable = () => {
    return vendorRequestChange.poCode && vendorRequestChange.poCode.length > 0
      ? true
      : false;
  };

  const isNewCopany = () => {
    return vendorRequestChange.coCode && vendorRequestChange.coCode !== companyCode ? true : false;
  };

  const handlePermittedPayeeAddPress = () => {
    setOpenPermittedPayeeDialog(true);
  };

  const handlePermittedPayeeClose = () => {
    setOpenPermittedPayeeDialog(false);
  };

  const handleUpdatePermittedPayee = (sapVendorList: Array<SAPVendor>) => {
    setOpenPermittedPayeeDialog(false);
    if (sapVendorList && sapVendorList.length > 0) {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "permittedPayeeList": sapVendorList.map((row) => {
          return row.vendor;
        }),
      });
    } else {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "permittedPayeeList": [],
      });
    }
  };

  const handleChangeAutoCompete = (e: any, input: string, newValue: any) => {
    if (input === "alternativeCurrency") {
      let selectedCodeList: string[] = [];
      if (newValue) {
        selectedCodeList = newValue.map(function (item: SettlementCurrency) {
          return item.code;
        });
      }
      if (newValue) {
        setVendorRequestChange({
          ...vendorRequestChange!,
          [input]: selectedCodeList,
        });
      } else {
        setVendorRequestChange({
          ...vendorRequestChange!,
          [input]: [],
        });
      }
    } else if (input === "orderCurrency") {
      setVendorRequestChange({
        ...vendorRequestChange!,
        "orderCurrency": newValue ? newValue.code : "",
        "alternativeCurrency": newValue
          ? vendorRequestChange.alternativeCurrency.filter((code: string) => {
            return code !== newValue.code;
          })
          : [],
      });
    }
    else if (input === "addressCoutry") {
      if (newValue) {
        setVendorRequestChange({
          ...vendorRequestChange!,
          [input]: newValue.code
        });
        getPreferedPaymentMethods(vendorRequestChange.coCode
          , newValue.code
          , (paymethodsList: Array<PaymentMethod>) => { setPaymentmethod(paymethodsList); }
          , () => { setPaymentmethod([]); });
      } else {
        setVendorRequestChange({
          ...vendorRequestChange!,
          [input]: ""
        });
      }
    }
  };

  const filterOptionsOrderCurrency = createFilterOptions({
    stringify: (option: SettlementCurrency) => option.name,
  });

  const isPORequest = () => {
    return createVendor.PoCodes && createVendor.PoCodes.length > 0;
  };

  const isFieldsAvailable = (fieldName: string) => {
    if (fieldName == "alternativeCurrency") {
      return Common.getSapSystem() != "S4";
    }
  }

  const getPrcurementSubcategoryName = (subCategoryId: number) => {
    let sc = procurementSubCategorySummaries.find(r => r.procurmentSubcategoryId == subCategoryId);
    return sc ? (sc.procurmentCategoryName + '-' + sc.procurmentSubcategoryName) : '';
  }

  return (
    <div className={classes.popUpOuter}>
      <Dialog
        open={open}
        onClose={handleClose}
        onExit={handleExit}
        onEnter={handleEnter}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {title}
          {/* {translation.vendorchangepopup_unblock_title} */}
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description"> */}
          <div>
            <div>
              <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                  <span className={classes.createLbl}>
                    {translation.vendorchangepopup_department_lbl}
                  </span>
                  <div className={classes.inputWrapper_Req}>
                    <Select
                      variant="outlined"
                      value={vendorRequestChange.departmentId || ""}
                      onChange={handleChange("departmentId")}
                      error={getErrorState("departmentId")}
                    >
                      {departmentList.map((obj) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          {obj.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                  <span className={classes.createLbl}>
                    {translation.vendorchangepopup_comment_lbl}
                  </span>
                  <div className={classes.inputWrapper}>
                    <TextField
                      variant="outlined"
                      value={vendorRequestChange.comment || ""}
                      onChange={handleChange("comment")}
                      error={getErrorState("comment")}
                      inputProps={{
                        maxLength: FieldsLengthConstants.RequestComments,
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }} >
                  <span className={classes.createLbl}>
                    {translation.vendorchangepopup_co_lbl}
                  </span>
                  <div className={classes.inputWrapper_Req}>
                    {/* {requestMode == VendorForm1Modes.VendorInialExtend && (
                      <Select
                        disabled={
                          requestMode !== VendorForm1Modes.VendorInialExtend
                        }
                        variant="outlined"
                        value={vendorRequestChange.coCode || ""}
                        onChange={handleChange("coCode")}
                        error={getErrorState("coCode")}
                      >
                        {companyCodeList.map((obj) => (
                          <MenuItem key={obj.code} value={obj.code}>
                            {obj.name}
                          </MenuItem>
                        ))}
                      </Select>)
                    } */}
                    {/* {requestMode !== VendorForm1Modes.VendorInialExtend && ( */}
                      <TextField
                        variant="outlined"
                        value={vendorRequestChange.coCode || ""}
                      />
                      {/* )} */}
                  </div>
                </Grid>
                {/* {requestMode !== VendorForm1Modes.VendorInialExtend && ( */}
                  <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}
                  >
                    <span className={classes.createLbl}>
                      {translation.vendorchangepopup_po_lbl}
                    </span>
                    <div className={classes.inputWrapper}>
                      <Select
                        variant="outlined"
                        value={vendorRequestChange.poCode || ""}
                        onChange={handleChange("poCode")}
                        error={getErrorState("poCode")}
                        inputProps={{ readOnly: vendorRequestChange.isConfirmExistingData }}
                      >
                        <MenuItem value="">
                          <em>{translation.dropdown_empty_text}</em>
                        </MenuItem>
                        {poList.map((obj) => (
                          <MenuItem key={obj.code} value={obj.code}>
                            {obj.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {/*<TextField
                        variant="outlined"
                        value={vendorRequestChange.poCode || ""}
                      />*/}
                    </div>
                  </Grid>
                {/* )} */}
                {requestMode == VendorForm1Modes.VendorInialAmend && (
                  <Fragment>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendor_detail_basic_name_lbl}
                      </span>
                      <div className={classes.inputWrapper_Req}>
                        <TextField
                          variant="outlined"
                          value={vendorRequestChange.vendorName || ""}
                          onChange={handleChange("vendorName")}
                          error={getErrorState("vendorName")}
                          inputProps={{
                            maxLength: FieldsLengthConstants.VendorName,
                            readOnly: vendorRequestChange.isConfirmExistingData
                          }}
                        />
                      </div>
                    </Grid>
                    {createVendor.VendorCategoryId == VendorCategoryData.RM && (
                      <Fragment>
                        <Grid item container xs={12} sm={12} md={6} lg={4} >
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <span className={classes.createLbl}>
                              {translation.vendor_crete_form1_BulkSample_lbl}
                            </span>
                          </Grid>
                          <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} style={{ width: "50%", float: "left" }}>
                            {createVendor.IsBulk == false && (<div className={classes.switchDiv}>
                              <FormControl component="fieldset">
                                <FormLabel component="legend"></FormLabel>
                                <RadioGroup row aria-label="Bulk/Sample" name="IsBulk" value={vendorRequestChange.isBulk} onChange={handleChange("isBulk")}>
                                  <FormControlLabel value={true} checked={vendorRequestChange.isBulk === true} 
                                    control={<Radio />} disabled={vendorRequestChange.isConfirmExistingData} label="Bulk" />
                                  <FormControlLabel value={false} checked={vendorRequestChange.isBulk === false} 
                                    control={<Radio />} disabled={vendorRequestChange.isConfirmExistingData} label="Sample" />
                                </RadioGroup>
                              </FormControl>
                            </div>)}
                            {createVendor.IsBulk && (
                              <span>Bulk</span>
                            )}
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <span className={classes.createLbl}>
                              {translation.vendor_crete_form1_RMCategory_lbl}
                            </span>
                          </Grid>
                          <Grid className={classes.inputWrapper_Req}>
                            <Select
                              variant="outlined"
                              value={vendorRequestChange.rmCategoryIds[0] || 0}
                              onChange={handleChange("rmCategoryIds")}
                              error={getErrorState("rmCategoryIds")}
                              inputProps={{ readOnly: createVendor.RMCategoryIds[0] 
                                && vendorRequestChange.isConfirmExistingData }}
                            >
                              <MenuItem value="">
                                <em>{translation.dropdown_empty_text}</em>
                              </MenuItem>
                              {rmCategories.map((obj) => (
                                <MenuItem key={obj.id} value={obj.id}>
                                  {obj.rmCategoryName}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>
                        </Grid>
                      </Fragment>)
                    }
                    {(createVendor.VendorCategoryId == VendorCategoryData.NonRM
                      || createVendor.VendorCategoryId == VendorCategoryData.Services
                    ) && (
                        <Fragment>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <span className={classes.createLbl}>
                                {translation.vendor_crete_form1_procurement_cat_lbl}
                              </span>
                            </Grid>
                            <Grid className={classes.inputWrapper_Req}>
                              <Select
                                variant="outlined"
                                value={vendorRequestChange.procurementCategoryIds[0] || 0}
                                onChange={handleChange("procurementCategoryIds")}
                                error={getErrorState("procurementCategoryIds")}
                                inputProps={{ readOnly: createVendor.ProcurementCategoryIds[0] 
                                  && vendorRequestChange.isConfirmExistingData }}
                              >
                                <MenuItem value="">
                                  <em>{translation.dropdown_empty_text}</em>
                                </MenuItem>
                                {procurementCategories.map((obj) => (
                                  <MenuItem key={obj.procurmentCategoryId} value={obj.procurmentCategoryId}>
                                    {obj.procurmentCategoryName}
                                  </MenuItem>
                                ))}
                              </Select>
                              {/* <Select
                            variant="outlined"
                            multiple
                            value={vendorRequestChange.procurementCategoryIds || []}
                            onChange={handleChange("procurementCategoryIds")}
                            error={getErrorState("procurementCategoryIds")}
                            renderValue={(selected) => (
                              <div>
                                {(selected as number[]).map((value) => (
                                  <Chip
                                    key={value}
                                    label={procurementCategories.find(r=> r.procurmentCategoryId == value)?.procurmentCategoryName}
                                    clickable
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) => event.stopPropagation()}
                                      />
                                    }
                                    onDelete={(e) => handleDelete(e, value, "procurementCategoryIds")}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {procurementCategories.map((obj) => (
                              <MenuItem key={obj.procurmentCategoryId} value={obj.procurmentCategoryId}>
                                <Checkbox
                                  checked={vendorRequestChange.procurementCategoryIds.includes(obj.procurmentCategoryId)}
                                />
                                <ListItemText primary={obj.procurmentCategoryName} />
                              </MenuItem>
                            ))}
                          </Select> */}
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <span className={classes.createLbl}>
                                {translation.vendor_crete_form1_procurement_subcat_lbl}
                              </span>
                            </Grid>
                            <Grid className={classes.inputWrapper_Req}>
                              <Select
                                variant="outlined"
                                value={vendorRequestChange.procurementSubcategoryIds[0] || 0}
                                onChange={handleChange("procurementSubcategoryIds")}
                                error={getErrorState("procurementSubcategoryIds")}
                                inputProps={{ readOnly: createVendor.ProcurementSubcategoryIds[0] 
                                  && vendorRequestChange.isConfirmExistingData }}
                              >
                                <MenuItem value="">
                                  <em>{translation.dropdown_empty_text}</em>
                                </MenuItem>
                                {procurementSubCategories.map((obj) => (
                                  <MenuItem key={obj.procurmentSubcategoryId} value={obj.procurmentSubcategoryId}>
                                    {MasterDataUtil.getNameFromProcSubCategorName(obj.procurmentSubcategoryName)}
                                  </MenuItem>
                                ))}
                              </Select>
                              <span className={classes.helpLbl}>{
                                MasterDataUtil.getSpendMngByFromProcSubCategorId(procurementSubCategories
                                ,vendorRequestChange.procurementSubcategoryIds[0] || 0)}
                              </span>
                              {/* <Select
                            variant="outlined"
                            multiple
                            value={vendorRequestChange.procurementSubcategoryIds || []}
                            onChange={handleChange("procurementSubcategoryIds")}
                            error={getErrorState("procurementSubcategoryIds")}
                            renderValue={(selected) => (
                              <div>
                                {(selected as number[]).map((value) => (
                                  <Chip
                                    key={value}
                                    label={getPrcurementSubcategoryName(value)}
                                    clickable
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) => event.stopPropagation()}
                                      />
                                    }
                                    onDelete={(e) => handleDelete(e, value, "procurementSubcategoryIds")}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {procurementSubCategories.map((obj) => (
                              <MenuItem key={obj.procurmentSubcategoryId} value={obj.procurmentSubcategoryId}>
                                <Checkbox
                                  checked={vendorRequestChange.procurementSubcategoryIds.includes(obj.procurmentSubcategoryId)}
                                />
                                <ListItemText primary={ getPrcurementSubcategoryName(obj.procurmentSubcategoryId) } />
                              </MenuItem>
                            ))}
                          </Select> */}
                            </Grid>
                          </Grid>
                        </Fragment>)
                    }
                    {(createVendor.VendorCategoryId == VendorCategoryData.RM
                      || createVendor.VendorCategoryId == VendorCategoryData.NonRM
                      || createVendor.VendorCategoryId == VendorCategoryData.Services) && (
                        <Fragment>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <span className={classes.createLbl}>
                                {translation.vendor_crete_form1_OnBoard_Reason_lbl}
                              </span>
                            </Grid>
                            <Grid className={classes.inputWrapper_Req}>
                              <Select
                                variant="outlined"
                                multiple
                                value={vendorRequestChange.onBoardReasonIds || []}
                                onChange={handleChange("onBoardReasonIds")}
                                error={getErrorState("onBoardReasonIds")}
                                inputProps={{ readOnly: vendorRequestChange.isConfirmExistingData }}
                                renderValue={(selected) => (
                                  <div>
                                    {(selected as number[]).map((value) => (
                                      <Chip
                                        key={value}
                                        label={vendorOnboardingReasons.find(r => r.id == value)?.vendorOnboardingReasonName}
                                        clickable
                                        deleteIcon={
                                          <CancelIcon
                                            onMouseDown={(event) => event.stopPropagation()}
                                          />
                                        }
                                        onDelete={(e) => handleDelete(e, value, "onBoardReasonIds")}
                                      />
                                    ))}
                                  </div>
                                )}
                              >
                                {vendorOnboardingReasons.map((obj) => (
                                  <MenuItem key={obj.id} value={obj.id}>
                                    <Checkbox
                                      disabled={!isOnboardingReasonActive(obj.id)}
                                      checked={vendorRequestChange.onBoardReasonIds.includes(obj.id)}
                                    />
                                    <ListItemText primary={obj.vendorOnboardingReasonName} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <span className={classes.createLbl}>
                                {translation.vendor_crete_form1_OBRDescript_lbl}
                              </span>
                            </Grid>
                            <Grid className={createVendor.VendorCategoryId == VendorCategoryData.RM ? classes.inputWrapper_Req : classes.inputWrapper}>
                              <TextField
                                multiline
                                maxRows={4}
                                variant="outlined"
                                value={vendorRequestChange.onBoardReasonDescription || ""}
                                onChange={handleChange("onBoardReasonDescription")}
                                error={getErrorState("onBoardReasonDescription")}
                                inputProps={{ maxLength: FieldsLengthConstants.VendoOnboardDescript,
                                  readOnly: vendorRequestChange.isConfirmExistingData
                                 }}
                              />
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4} >
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <span className={classes.createLbl}>
                                {translation.vendor_create_onboardreasonupload_lbl}
                              </span>
                            </Grid>
                            <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
                              <div className={classes.fileWrapper}>
                                <FileUpload
                                  editable={!vendorRequestChange.isConfirmExistingData}
                                  requestNumber={createVendor.RequestNumber}
                                  userfile={vendorRequestChange.onboardReasonFile}
                                  attachmentType={FileUploadTypes.OnboardingReasonDoc}
                                ></FileUpload>
                              </div>
                            </Grid>
                          </Grid>
                        </Fragment>
                      )}
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_recon_lbl}
                      </span>
                      <div className={classes.inputWrapper_Req}>
                        <Select
                          variant="outlined"
                          value={vendorRequestChange.reconAC || ""}
                          onChange={handleChange("reconAC")}
                          error={getErrorState("reconAC")}
                          inputProps={{ readOnly: vendorRequestChange.isConfirmExistingData }}
                        >
                          {reconAcList.map((obj) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              {obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_subcategory_lbl}
                      </span>
                      <div className={classes.inputWrapper_Req}>
                        <Select
                          variant="outlined"
                          value={vendorRequestChange.typeSubCategory || ""}
                          onChange={handleChange("typeSubCategory")}
                          error={getErrorState("typeSubCategory")}
                          inputProps={{ readOnly: vendorRequestChange.isConfirmExistingData }}
                        >
                          {secondCategories.map((obj) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              {obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <span className={classes.createLbl}>
                        {translation.vendor_detail_contactdetails_country_lbl}
                      </span>
                      <Grid className={classes.inputWrapper_Req}>
                        <Autocomplete
                          options={countries.map((obj: Country) => obj)}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, newValue) => {
                            e.preventDefault();
                            handleChangeAutoCompete(e, "addressCoutry", newValue);
                          }}
                          value={
                            countries.find(
                              (element: Country) =>
                                element.code === vendorRequestChange.addressCoutry
                            ) || null
                          }
                          disabled={vendorRequestChange.isConfirmExistingData}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              margin="normal"
                              variant="outlined"
                              error={getErrorState("addressCoutry")}
                              inputProps={{
                                ...params.inputProps,
                              }}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    {isPORequest() && (
                      <Grid item xs={12} sm={12} md={6} lg={4} >
                        <span className={classes.createLbl}>
                          {translation.vendor_detail_paymentdetails_termtrd_lbl}
                        </span>
                        <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                          <Select
                            variant="outlined"
                            value={vendorRequestChange.termsOfTrade || ""}
                            onChange={handleChange("termsOfTrade")}
                            error={getErrorState("termsOfTrade")}
                            inputProps={{ readOnly: vendorRequestChange.isConfirmExistingData }}
                          >
                            {termstrade.map((obj: TermsTrade) => (
                              <MenuItem key={obj.code} value={obj.code}>
                                {obj.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={12} md={6} lg={4} >
                      <span className={classes.createLbl}>
                        {translation.vendor_detail_paymentdetails_paymethod_lbl}
                      </span>
                      <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                        <Select
                          variant="outlined"
                          multiple
                          value={vendorRequestChange.paymentMethodCode || []}
                          onChange={handleChange("paymentMethodCode")}
                          error={getErrorState("paymentMethodCode")}
                          disabled={vendorRequestChange.isConfirmExistingData}
                          renderValue={(selected) => (
                            <div>
                              {(selected as string[]).map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  clickable
                                  disabled={vendorRequestChange.isConfirmExistingData}
                                  deleteIcon={(
                                    <CancelIcon
                                      onMouseDown={(event) => event.stopPropagation()}
                                    />)
                                  }
                                  onDelete={(e) => handleDelete(e, value, "paymentMethodCode")}
                                />
                              ))}
                            </div>
                          )}
                        >
                          {paymentmethod.map((obj: PaymentMethod) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              <Checkbox
                                checked={vendorRequestChange.paymentMethodCode.includes(obj.code)}
                              />
                              <ListItemText primary={obj.name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} >
                      <span className={classes.createLbl}>
                        {translation.vendor_detail_paymentdetails_credperiod_lbl}
                      </span>
                      <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                        <Select
                          variant="outlined"
                          value={vendorRequestChange.creditPeriodDays || ""}
                          onChange={handleChange("creditPeriodDays")}
                          error={getErrorState("creditPeriodDays")}
                          inputProps={{ readOnly: vendorRequestChange.isConfirmExistingData }}
                        >
                          {crediperioddays.map((obj: CreditPeriodDays) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              {obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                    {isRmOrNonRmOrServices() && (
                      <Fragment>
                        <Grid item xs={12} sm={12} md={6} lg={4} >
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <span className={classes.createLbl}>
                              {translation.vendor_detail_bankdetails_purposecode_lbl}
                            </span>
                          </Grid>
                          <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
                            <Select
                              variant="outlined"
                              value={vendorRequestChange.purposeCode || ""}
                              onChange={handleChange("purposeCode")}
                              error={getErrorState("purposeCode")}
                              inputProps={{ readOnly: vendorRequestChange.isConfirmExistingData }}
                            >
                              <MenuItem value="">
                                <em>{translation.dropdown_empty_text}</em>
                              </MenuItem>
                              {paymentpurposeList.map((obj: PaymentPurpose) => (
                                <MenuItem key={obj.code} value={obj.code}>
                                  {obj.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} >
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <span className={classes.createLbl}>
                              {translation.individualPayPopup_instruction_key_lbl}
                            </span>
                          </Grid>
                          <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
                            <Autocomplete
                              options={instructionKeyList.map((obj) => obj)}
                              getOptionLabel={(option) => option.name}
                              onChange={(e, newValue) => {
                                e.preventDefault();
                                handleChangeAutoCompete(e, "instructionKey", newValue);
                              }}
                              value={
                                instructionKeyList.find((element) =>
                                  element.code === vendorRequestChange.instructionKey) || null
                              }
                              disabled={vendorRequestChange.isConfirmExistingData}
                              renderOption={(option, props) => (
                                <li {...props}>
                                  {option.name}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  margin="normal"
                                  error={getErrorState("instructionKey")}
                                  inputProps={{
                                    ...params.inputProps,
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Fragment>)
                    }
                    {isPORequest() && (
                      <Grid item xs={12} sm={12} md={6} lg={4} >
                        <span className={classes.createLbl}>
                          {translation.vendor_detail_paymentdetails_currencyorder_lbl}
                        </span>
                        <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                          <Autocomplete
                            options={settlementcurrency.map(
                              (obj: SettlementCurrency) => obj
                            )}
                            getOptionLabel={(option) => option.code}
                            filterOptions={filterOptionsOrderCurrency}
                            onChange={(e, newValue) => {
                              e.preventDefault();
                              handleChangeAutoCompete(e, "orderCurrency", newValue);
                            }}
                            value={
                              settlementcurrency.find(
                                (element: SettlementCurrency) =>
                                  element.code === vendorRequestChange.orderCurrency
                              ) || null
                            }
                            disabled={vendorRequestChange.isConfirmExistingData}
                            renderOption={(option) => option.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                margin="normal"
                                variant="outlined"
                                error={getErrorState("orderCurrency")}
                                inputProps={{
                                  ...params.inputProps,
                                }}
                              />
                            )}
                          />
                          <span className={classes.helpLbl}>{translation.vendor_detail_paymentdetails_currencyorder_help}</span>
                        </Grid>
                      </Grid>
                    )}
                    {isPORequest() && (isFieldsAvailable("alternativeCurrency")) && (
                      <Grid item xs={12} sm={12} md={6} lg={4} className={!vendorRequestChange.orderCurrency ? classes.compDisableCls : ""} >
                        <span className={classes.createLbl}>
                          {translation.vendor_detail_paymentdetails_currencyst_lbl}
                        </span>
                        <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
                          <Autocomplete
                            multiple
                            options={settlementcurrency.filter(
                              (element: SettlementCurrency) => {
                                return vendorRequestChange.orderCurrency !== element.code;
                              }
                            )}
                            disableCloseOnSelect
                            value={
                              settlementcurrency.filter((element: SettlementCurrency) =>
                                vendorRequestChange.alternativeCurrency.includes(element.code)
                              ) || null
                            }
                            disabled={vendorRequestChange.isConfirmExistingData}
                            getOptionLabel={(option) => option.name}
                            onChange={(e, newValue) => {
                              e.preventDefault();
                              handleChangeAutoCompete(e, "alternativeCurrency", newValue);
                            }}
                            renderOption={(option, { selected }) => (
                              <React.Fragment>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option.name}
                              </React.Fragment>
                            )}
                            renderTags={(value: SettlementCurrency[], getTagProps) =>
                              value.map((option: SettlementCurrency, index: number) => (
                                <Chip label={option.code} {...getTagProps({ index })} />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                error={getErrorState("alternativeCurrency")}
                                inputProps={{
                                  ...params.inputProps,
                                }}
                              />
                            )}
                          />
                          <span className={classes.helpLbl}>{translation.vendor_detail_paymentdetails_currencyst_help}</span>
                        </Grid>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_mobilenum_lbl}
                      </span>
                      <div className={classes.inputWrapper_Req}>
                        <TextField
                          variant="outlined"
                          value={vendorRequestChange.mobileNumber || ""}
                          onChange={handleChange("mobileNumber")}
                          error={getErrorState("mobileNumber")}
                          inputProps={{
                            maxLength: FieldsLengthConstants.VendorMobileNumber
                            //,readOnly:vendorRequestChange.isConfirmExistingData
                          }}
                        />
                        <span className={classes.helpLbl}>{translation.vendor_crete_form1_mobilenum_help}</span>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_email_lbl}
                      </span>
                      <div className={vendorRequestChange.isVendorFillForm2 ? classes.inputWrapper_Req : classes.inputWrapper}>
                        <TextField
                          variant="outlined"
                          value={vendorRequestChange.email || ""}
                          onChange={handleChange("email")}
                          error={getErrorState("email")}
                          inputProps={{
                            maxLength: FieldsLengthConstants.VendorEmail,
                            readOnly:vendorRequestChange.isConfirmExistingData
                          }}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_vendorfillsform2_lbl}
                      </span>
                      <div >
                        <Checkbox
                          checked={vendorRequestChange.isVendorFillForm2}
                          onChange={handleChange("isVendorFillForm2")}
                          disabled={vendorRequestChange.isConfirmExistingData}
                          style={{ margin: "8px 0 0 0" }}
                        />
                      </div>
                    </Grid>
                    {isRmOrNonRmOrServices() && (
                      <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                        <span className={classes.createLbl}>
                          {translation.vendor_amend_form1_existing_data_confirm_lbl}
                        </span>
                        <div >
                          <Checkbox
                            checked={vendorRequestChange.isConfirmExistingData}
                            onChange={handleChange("isConfirmExistingData")}
                            style={{ margin: "8px 0 0 0" }}
                          />
                        </div>
                      </Grid>
                    )}
                  </Fragment>
                )}
                {/* {requestMode == VendorForm1Modes.VendorInialExtend && (
                  <Fragment>
                    {vendorType !== VendorTypeData.Employee && (
                      <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                        <span className={classes.createLbl}>
                          {translation.vendorchangepopup_po_lbl}
                        </span>
                        <div
                          className={(isPoRequired()) ? classes.inputWrapper_Req : classes.inputWrapper}
                        >
                          <Select
                            variant="outlined"
                            multiple
                            value={vendorRequestChange.poCode || []}
                            onChange={handleChange("poCode")}
                            error={getErrorState("poCode")}
                            renderValue={(selected) => (
                              <div>
                                {(selected as string[]).map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    clickable
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) =>
                                          event.stopPropagation()
                                        }
                                      />
                                    }
                                    onDelete={(e) =>
                                      handleDelete(e, value, "poCode")
                                    }
                                    onClick={() => console.log("clicked chip")}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {poList.map((obj) => (
                              <MenuItem key={obj.code} value={obj.code}>
                                <Checkbox
                                  checked={vendorRequestChange.poCode.includes(
                                    obj.code
                                  )}
                                />
                                <ListItemText primary={obj.name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </Grid>)}
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendorchangepopup_recon_lbl}
                      </span>
                      <div
                        className={
                          isNewCopany()
                            ? classes.inputWrapper_Req
                            : classes.inputWrapper
                        }
                      >
                        <Select
                          disabled={!isNewCopany()}
                          variant="outlined"
                          value={vendorRequestChange.reconACCode || ""}
                          onChange={handleChange("reconACCode")}
                          error={getErrorState("reconACCode")}
                        >
                          {reconAcList.map((obj) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              {obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendorchangepopup_payment_lbl}
                      </span>
                      <div
                        className={
                          isNewCopany()
                            ? classes.inputWrapper_Req
                            : classes.inputWrapper
                        }
                      >
                        <Select
                          variant="outlined"
                          multiple
                          value={vendorRequestChange.paymentMethodCode || []}
                          onChange={handleChange("paymentMethodCode")}
                          error={getErrorState("paymentMethodCode")}
                          renderValue={(selected) => (
                            <div>
                              {(selected as string[]).map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  clickable
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) => event.stopPropagation()}
                                    />
                                  }
                                  onDelete={(e) => handleDelete(e, value, "paymentMethodCode")}
                                />
                              ))}
                            </div>
                          )}
                        >
                          {paymentmethod.map((obj: PaymentMethod) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              <Checkbox
                                checked={vendorRequestChange.paymentMethodCode.includes(obj.code)}
                              />
                              <ListItemText primary={obj.name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {
                          translation.vendor_detail_paymentdetails_permittedpayee_lbl
                        }
                      </span>
                      <div className={classes.inputWrapper}>
                        <div className={classes.addBtnWrapper}>
                          <Button
                            onClick={handlePermittedPayeeAddPress}
                            disabled={!isNewCopany()}
                          >
                            <AddCircleIcon></AddCircleIcon>
                            {
                              translation.vendor_detail_paymentdetails_permittedpay_addbtntxt
                            }
                          </Button>
                        </div>
                        {vendorRequestChange.permittedPayeeList && (
                          <span className={classes.textWrap}>
                            {Util.concateStringArray(
                              vendorRequestChange.permittedPayeeList
                            )}
                          </span>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendorchangepopup_housebank_lbl}
                      </span>
                      <div className={classes.inputWrapper} >
                        <Select
                          disabled={!isNewCopany()}
                          variant="outlined"
                          value={vendorRequestChange.houseBankCode || ""}
                          onChange={handleChange("houseBankCode")}
                          error={getErrorState("houseBankCode")}
                        >
                          {housebanks.map((obj) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              {obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendorchangepopup_creaditperd_lbl}
                      </span>
                      <div className={classes.inputWrapper_Req}>
                        <Select
                          variant="outlined"
                          value={vendorRequestChange.creditPeriodDays || ""}
                          onChange={handleChange("creditPeriodDays")}
                          error={getErrorState("creditPeriodDays")}
                        >
                          {crediperioddays.map((obj) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              {obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendorchangepopup_ordercrncy_lbl}
                      </span>
                      <div
                        className={
                          isPoAvailable()
                            ? classes.inputWrapper_Req
                            : classes.inputWrapper
                        }
                      >
                        <Autocomplete
                          disabled={!isPoAvailable()}
                          options={settlementcurrency.map(
                            (obj: SettlementCurrency) => obj
                          )}
                          getOptionLabel={(option) => option.code}
                          filterOptions={filterOptionsOrderCurrency}
                          onChange={(e, newValue) => {
                            e.preventDefault();
                            handleChangeAutoCompete(e, "orderCurrency", newValue);
                          }}
                          value={
                            settlementcurrency.find(
                              (element: SettlementCurrency) =>
                                element.code === vendorRequestChange.orderCurrency
                            ) || null
                          }
                          renderOption={(option) => option.name}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              margin="normal"
                              variant="outlined"
                              error={getErrorState("orderCurrency")}
                              inputProps={{
                                ...params.inputProps,
                              }}
                            />
                          )}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendorchangepopup_settlementcrncy_lbl}
                      </span>
                      <div className={classes.inputWrapper}>
                        <Autocomplete
                          disabled={
                            !isPoAvailable() || !vendorRequestChange.orderCurrency
                          }
                          multiple
                          options={settlementcurrency.filter(
                            (element: SettlementCurrency) => {
                              return (
                                vendorRequestChange.orderCurrency !== element.code
                              );
                            }
                          )}
                          disableCloseOnSelect
                          value={
                            settlementcurrency.filter((element) =>
                              vendorRequestChange.alternativeCurrency.includes(
                                element.code
                              )
                            ) || null
                          }
                          getOptionLabel={(option) => option.name}
                          onChange={(e, newValue) => {
                            e.preventDefault();
                            handleChangeAutoCompete(
                              e,
                              "alternativeCurrency",
                              newValue
                            );
                          }}
                          renderOption={(option, { selected }) => (
                            <React.Fragment>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.name}
                            </React.Fragment>
                          )}
                          renderTags={(
                            value: SettlementCurrency[],
                            getTagProps
                          ) =>
                            value.map(
                              (option: SettlementCurrency, index: number) => (
                                <Chip
                                  label={option.code}
                                  {...getTagProps({ index })}
                                />
                              )
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              margin="normal"
                              error={getErrorState("alternativeCurrency")}
                              inputProps={{
                                ...params.inputProps,
                              }}
                            />
                          )}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendorchangepopup_termstra_lbl}
                      </span>
                      <div
                        className={
                          isPoAvailable()
                            ? classes.inputWrapper_Req
                            : classes.inputWrapper
                        }
                      >
                        <Select
                          disabled={!isPoAvailable()}
                          variant="outlined"
                          value={vendorRequestChange.termsOfTrade || ""}
                          onChange={handleChange("termsOfTrade")}
                          error={getErrorState("termsOfTrade")}
                        >
                          {termstrade.map((obj) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              {obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>
                  </Fragment>
                )} */}
              </Grid>
              {approver1List && approver1List.length > 0 && (<Fragment>
                <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} >
                  <span className={classes.popUpHeaderTxt}>
                    {translation.vendor_crete_form1_approvers_section_title}
                  </span>
                  <span className={classes.popUpHeaderLine}></span>
                </Grid>
                <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>{approver1Lable}</span>
                    </Grid>
                    <Grid className={classes.inputWrapper_Req}>
                      {(!isRmOrNonRmOrServices() || isServicesBySbu()) && (<Select
                        variant="outlined"
                        multiple
                        value={vendorRequestChange.firstApprovers || []}
                        onChange={handleChange("firstApprovers")}
                        error={getErrorState("firstApprovers")}
                        renderValue={(selected) => (
                          <div>
                            {(selected as string[]).map((value) => (
                              <Chip
                                key={value}
                                label={value}
                                clickable
                                deleteIcon={
                                  <CancelIcon
                                    onMouseDown={(event) => event.stopPropagation()}
                                  />
                                }
                                onDelete={(e) => handleDelete(e, value, "firstApprovers")}
                              />
                            ))}
                          </div>
                        )}
                      >
                        {approver1List.map((obj) => (
                          <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                            <Checkbox
                              checked={vendorRequestChange.firstApprovers.includes(obj.emailAddress)}
                            />
                            <ListItemText primary={obj.emailAddress} />
                          </MenuItem>
                        ))}
                      </Select>)}
                      {(isRmOrNonRmOrServices() && !isServicesBySbu()) && (
                        <span className={classes.textWrap}>
                          {`${approver1List.map((obj) => obj.emailAddress + ' ')}`}
                        </span>
                      )}
                    </Grid>
                  </Grid>
                  {approver2List.length > 0 && (<Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>{approver2Lable}</span>
                    </Grid>
                    <Grid className={classes.inputWrapper_Req}>
                      {!isRmOrNonRmOrServices() && (<Select
                        variant="outlined"
                        multiple
                        value={vendorRequestChange.secondApprovers || []}
                        onChange={handleChange("secondApprovers")}
                        error={getErrorState("secondApprovers")}
                        renderValue={(selected) => (
                          <div>
                            {(selected as string[]).map((value) => (
                              <Chip
                                key={value}
                                label={value}
                                clickable
                                deleteIcon={
                                  <CancelIcon
                                    onMouseDown={(event) => event.stopPropagation()}
                                  />
                                }
                                onDelete={(e) => handleDelete(e, value, "secondApprovers")}
                              />
                            ))}
                          </div>
                        )}
                      >
                        {approver2List.map((obj) => (
                          <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                            <Checkbox
                              checked={vendorRequestChange.secondApprovers.includes(obj.emailAddress)}
                            />
                            <ListItemText primary={obj.emailAddress} />
                          </MenuItem>
                        ))}
                      </Select>)}
                      {isRmOrNonRmOrServices() && (
                        <span className={classes.textWrap}>
                          {`${approver2List.map((obj) => obj.emailAddress + ' ')}`}
                        </span>
                      )}
                    </Grid>
                  </Grid>)}
                </Grid>
              </Fragment>)
              }
            </div>
          </div>
        </DialogContent>
        <div style={{ margin: "25px 0 0 0" }}>
          <DialogActions>
            <div style={{ margin: "20px ​10px 15px 0" }}>
              <div className={classes.greenBtnWrapper}>
                <Button onClick={handleConfirm} color="primary">
                  <CheckCircleIcon></CheckCircleIcon>
                  {translation.vendorchangepopup_amend_btn}
                </Button>
              </div>
              {/* )} */}

              <div className={classes.grayBtnWrapper}>
                <Button onClick={handleClose} color="primary" autoFocus>
                  {translation.vendorchangepopup_close_btn}
                </Button>
              </div>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      <VendorSelectDialog
        open={openPermittedPayeeDialog}
        title={translation.vendordetail_permittedvendor_popup_title}
        handleClose={handlePermittedPayeeClose}
        isEditmode={true}
        companyCode={vendorRequestChange.coCode}
        onUpdateConfirm={handleUpdatePermittedPayee}
        alreadySelectedVendors={vendorRequestChange.permittedPayeeList}
        nodataMsg={translation.vendordetail_permittedvendor_popup_nodta_msg}
        maxSelectItems={Max_PermittedPayee_For_Vendor}
        requestMode={requestMode}
        currentRequestVendor={createVendor.vendorNo}
      ></VendorSelectDialog>
      <ValidationErrors
        open={openValidateErrDialog}
        setOpen={setOpenValidateErrDialog}
        errorList={formErrors}
      ></ValidationErrors>
    </div>
  );
}
